import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InsertPhotoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"insert_photo"}/>
}
